import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

class TelemetryService {
  constructor() {
    this.reactPlugin = new ReactPlugin();
  }

  initialize(instrumentationKeyOrConnectionString, reactPluginConfig) {
    const config = {
      enableAutoRouteTracking: true,
      disableCookiesUsage: true,
      maxBatchInterval: 0,
      disableFetchTracking: false,
      extensions: [this.reactPlugin],
      extensionConfig: {
        [this.reactPlugin.identifier]: reactPluginConfig,
      },
    };

    if (typeof instrumentationKeyOrConnectionString === 'string') {
      if (instrumentationKeyOrConnectionString.includes('=')) {
        // Treat as connection string
        config.connectionString = instrumentationKeyOrConnectionString;
      } else {
        // Treat as instrumentation key
        config.instrumentationKey = instrumentationKeyOrConnectionString;
      }
    }

    this.appInsights = new ApplicationInsights({ config });
    this.appInsights.loadAppInsights();
  }
}

export let ai = new TelemetryService();
